export default __webpack_public_path__ + "static/media/logo-icon-light.96a69f75.svg";